import Vue from 'vue';
import Vuex, { StoreOptions} from 'vuex';
import { RootState } from './types.d';

Vue.use(Vuex);

import { linkToPay } from './modules/linkToPay';

const rootStore: StoreOptions<RootState> = {
  modules: {
    linkToPay,
  }
};

const store = new Vuex.Store<RootState>(rootStore);

export default store;